export default __webpack_public_path__ + "static/media/ig.002ae214.jpg";